import * as Sentry from '@sentry/browser';

const reportToSentry = (error: Error) => {
  Sentry.captureException(error);
};

export default reportToSentry;
